import * as jsxRuntime from "C:\\Eidos!!!\\Birkelybakke\\79-eido-3.0-birkely-bakke\\node_modules\\react\\jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment